import React, { useEffect, useState } from "react";
import { useParams, Link } from 'react-router-dom';
import AddNewTeam from "./AddNewTeam";
import TeamDataColumn from "./TeamDataColumn";
import { useCookies } from "react-cookie";
import configVars from "../../config";
import HviChart from "../Dashboard/HviChart";
import { getUserData } from "../../redux/actions/userdata";
import { useDispatch, useSelector } from "react-redux";
import OrganizationMembers from "./OrganizationMembers";
import { getExpiry } from '../../common';
import jwtDecode from "jwt-decode";
import { useTranslation } from "react-i18next";
import OrgOviSummary from "./OrgOviSummary";

const SingleTeam = (props) => {

    const { organization_id, team_id, sub_teams, sub_team_id } = useParams();
    const [cookies] = useCookies(["sustainyou_user_jwt"]);

    const [translation] = useTranslation("translations");

    //const [displayItem, setDisplayItem] = useState('hvi');

    const [teamHviData, setTeamHviData] = useState({});
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.userdata.allUserData);
    //const [graphsGenerated, setGraphsGenerated] = useState(false);
    const [activeColumn, seActiveColumn] = useState('hvi');
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [subTeams, setSubTeams] = useState([]);
    const [teamData, setTeamData] = useState([]);
    const [teamMembers, setTeamMembers] = useState([]);
    const [teamManager, setTeamManager] = useState([]);
    const [hasAccess, setHasAccess] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const hvidata = useSelector((state) => state.hvidata.hvidata);

    useEffect(() => {

        let expired = getExpiry("user_data_expire");
    
        const getAllUserData = async (token) => {
            setLoading(true);
            await dispatch(getUserData(token));
            setLoading(false)
        }
    
        if (cookies.sustainyou_user_jwt) {
            
            if (expired) {
                getAllUserData(cookies.sustainyou_user_jwt);
            }
        }
    
    
      }, [dispatch, cookies]);

    useEffect(() => {

        if ( ! team_id ) {
            return;
        }

        //console.log( sub_team_id );

        if ( props?.owner && props?.owner?.id ) {

            const ownderID =   parseInt( props?.owner?.id, 10);
            const decoded = jwtDecode( cookies.sustainyou_user_jwt );
            const loggedInUserID = parseInt( decoded?.id, 10 );

            if ( ownderID === loggedInUserID ) {
                setHasAccess(true);
                setCanEdit(true);
            }

        }


        (async () => {

            setLoading( true );

            let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'company_id', organization_id );

            if ( sub_team_id ) {
                userRequestData.append( 'team_id', sub_team_id );
            } else {
                userRequestData.append( 'team_id', team_id );
            }

            const fetchUrl = `${configVars.apiUrl}sustainteams/v1/sustaingetteamdata/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const teamResponse = await response.json();
        
                if ( teamResponse ) {

                    if ( teamResponse.data.team_result && teamResponse.data.team_result.length > 0 ) {

                        const decoded = jwtDecode( cookies.sustainyou_user_jwt );
                        const loggedInUserID = parseInt( decoded?.id, 10 );

                        //const allTeamData = JSON.parse( teamResponse.data.team_result );

                        const team_data = teamResponse.data.team_data[0];

                        if ( team_data && props.allMembers && props.allMembers.length > 0 ) {

                            setTeamData(team_data);

                            const memberIds = JSON.parse(team_data.team_users);
                            let team_members;
                            let team_manager;
                    
                            if ( memberIds ) {
                                team_members = props.allMembers.filter(obj => {
                                    return memberIds.includes( obj.id );
                                })
                
                                setTeamMembers(team_members);

                                if ( memberIds.includes( loggedInUserID ) ) {
                                    setHasAccess(true);
                                }
                            }
                    
                            team_manager = props.allMembers.filter(obj => {
                                return obj.id === parseInt( team_data.manager_id, 10);
                            });
                
                            setTeamManager( team_manager );

                            if ( loggedInUserID === parseInt( team_data.manager_id, 10) ) {
                                setHasAccess(true);
                                setCanEdit(true);
                            }

                            let teamHvi = [];

                            teamResponse.data.team_result.map( (item) => {
                                let itemHvi = null;

                                if (item.hvi && item.hvi.length > 0 ) {
                                    
                                    itemHvi = JSON.parse( item.hvi );
                                    const recentHvi = [...itemHvi].pop();

                                    itemHvi = itemHvi.reverse().filter((value, index, self) =>
                                        index === self.findIndex((t) => (
                                            t.date === value.date
                                        ))
                                    )
                                    
                                    teamHvi.push({
                                        user_id: parseInt( item.user_id, 10 ),
                                        member_hvi_all: itemHvi,
                                        member_hvi: recentHvi
                                    });
                                }

                                return itemHvi;
                            })

                            setTeamHviData({
                                members_count: memberIds.length,
                                organization: teamHvi,
                                personal: []
                            });
                            //setGraphsGenerated(true);
                    
                        }

                    }
                    
                    if ( teamResponse.data.sub_teams ) {
                        setSubTeams( teamResponse.data.sub_teams );
                    }

                    //console.log( teamResponse.data );

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setLoading( false );

        })()

    }, [cookies.sustainyou_user_jwt, organization_id, team_id, props.allMembers, sub_team_id, props.owner]);

    const handleTeamDelete = async () => {
        
        setLoading( true );

            let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'company_id', organization_id );
            
            if ( sub_team_id ) {
                userRequestData.append( 'team_id', sub_team_id );
            } else {
                userRequestData.append( 'team_id', team_id );
            }

            const fetchUrl = `${configVars.apiUrl}sustainteams/v1/sustaindeteleteam/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const teamResponse = await response.json();
        
                if ( teamResponse ) {

                    if ( teamResponse.success === true ) {
                        localStorage.removeItem( `sy_org_${organization_id}_data` );
                        window.location.replace( `/organizations/${organization_id}/teams/` );
                    } else {
                        setDeleteConfirm(false);
                    }
                    
                    //console.log( teamResponse );

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setLoading( false );

    }

    if ( !hasAccess && !Object.values(userData?.roles).includes("administrator") ) {
        return(
            <div>
                {loading &&
                    <div className="d-flex">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                }

                {!loading &&
                    <div className="alert alert-danger" role="alert">
                        {translation("team_no_access")}
                    </div>
                }
            </div>
        )
    }

    return (
        <div>

            { teamData &&
                <>
                    <h3 className="mb-4">{teamData.team_name}</h3>

                    { sub_teams && sub_teams === 'new-sub-team' &&
                        <AddNewTeam members={teamMembers} />
                    }

                    { sub_teams && sub_teams === 'members' &&
                        <OrganizationMembers members={teamMembers} />
                    }

                    { sub_teams && sub_teams === 'edit' &&
                        <AddNewTeam members={props.allMembers} type="edit" teamData={teamData} selectedMembers={teamMembers} />
                    }

                    {loading &&
                        <div className="d-flex">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    }

                    { (!sub_teams || (sub_team_id && (sub_teams !== 'members' && sub_teams !== 'edit')) ) && !loading &&
                        <div className="row">
                            <div className="col-12 col-lg-12">

                                <div className="row">
                                    <div className={`col-12 col-lg-4 mb-4 team-column-wrap position-relative ${ activeColumn === 'hvi' ? 'active' : ''}`} onClick={() => seActiveColumn('hvi')}>
                                        <TeamDataColumn
                                            title="HWI"
                                            subTitle="Human Well-being Index"
                                            icon="smile-o"
                                            isSelected={activeColumn === 'hvi' ? true : false}
                                            hviArray={hvidata[`team_${team_id}`]}
                                        />
                                    </div>
                                    <div className={`col-12 col-lg-4 mb-4 team-column-wrap position-relative ${ activeColumn === 'ovi' ? 'active' : ''}`} onClick={() => seActiveColumn('ovi')}>
                                        <TeamDataColumn
                                            title="OWI"
                                            subTitle="Organisation Well function Index"
                                            icon="users"
                                            isSelected={activeColumn === 'ovi' ? true : false}
                                        />
                                    </div>
                                    <div className={`col-12 col-lg-4 mb-4 team-column-wrap position-relative ${ activeColumn === 'admin' ? 'active' : ''}`} onClick={() => seActiveColumn('admin')}>
                                        <TeamDataColumn
                                            title="Team inställningar"
                                            subTitle="hantera team och användare"
                                            icon="cogs"
                                            isSelected={activeColumn === 'admin' ? true : false}
                                        />
                                    </div>
                                </div>

                                {activeColumn === 'hvi' &&
                                    <HviChart hvi={teamHviData} loading={loading} organization={ sub_team_id || team_id } roles={userData?.roles} gtg={false} />
                                }

                                {activeColumn === 'ovi' &&
                                     <OrgOviSummary roles={userData?.roles} />
                                }

                            </div>

                            {activeColumn === 'admin' &&
                                <div className="row">

                                    { teamManager && teamManager[0] &&
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <div className="team-members-wrap h-100 bg-white shadow-sm pt-3 pb-5 px-4 d-flex flex-column justify-content-center border rounded-3 mb-4">
                                                <div className="d-flex align-items-center flex-column">
                                                    <h4>{translation("team_manager")}</h4>

                                                    <div className="team-members d-flex mt-3 flex-column justify-content-center align-items-center">
                                                        <div>
                                                            <img src={teamManager[0]?.avatar} className="rounded-circle" alt="manager-thumb" />
                                                        </div>
                                                        <h5 className="mt-3">{teamManager[0]?.name}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    }

                                    { teamMembers &&
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <div className="team-members-wrap h-100 bg-white shadow-sm pt-3 pb-5 px-4 d-flex flex-column justify-content-center border rounded-3">
                                            
                                                <div className="d-flex align-items-center flex-column">
                                                    <h4>{translation("members_text")}</h4>

                                                    <div className="team-members d-flex mt-2 align-items-center mb-4">

                                                        { teamMembers.slice(0, 5).map((member, index) => {
                                                            return(
                                                                <div className="rounded-circle" key={index} 
                                                                    style={{ 
                                                                        width: "35px",
                                                                        height: "35px",
                                                                        backgroundImage: `url(${member?.avatar})`,
                                                                        backgroundSize: "cover"
                                                                    }}
                                                                >

                                                                </div>
                                                            )
                                                        })}

                                                        {teamMembers.length > 5 &&
                                                            <span className="text-primary font-size-medium ms-1">+{teamMembers.length - 5} more</span>
                                                        }

                                                    </div>
                                                </div>

                                                <Link to={`/organizations/${organization_id}/teams/${team_id}/members/${sub_team_id || ''}`} className="btn btn-primary text-white mb-2 rounded-pill" >
                                                    <span className="pe-2">{translation("view_members")}</span>
                                                    <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                                </Link>

                                                {(canEdit || Object.values(userData?.roles).includes("administrator") ) &&
                                                    <Link to={`/organizations/${organization_id}/teams/${team_id}/edit/${sub_team_id || ''}`} className="btn btn-halite-blue mb-2 rounded-pill" >
                                                        <span className="pe-2">{translation("edit_team")}</span>
                                                        <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                                    </Link>
                                                }
                                                
                                                { !deleteConfirm && !loading && ( ! subTeams || subTeams.length === 0 ) && (canEdit || Object.values(userData?.roles).includes("administrator") ) &&
                                                    <button type="button" className="btn btn-secondary rounded-pill" onClick={() => setDeleteConfirm(true)}>
                                                        <span className="pe-2">{translation("delete_team")}</span>
                                                        <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                                    </button>
                                                }

                                                { deleteConfirm &&
                                                    <div className="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                                                        <div className="toast-header">
                                                            <strong className="me-auto">{translation("are_you_sure")}</strong>
                                                            <button type="button" className="btn-close" aria-label="Close" onClick={() => setDeleteConfirm(false)}></button>
                                                        </div>
                                                        <div className="toast-body">
                                                            {translation("team_delete_warning")}
                                                            <div className="mt-2 pt-2 d-flex justify-content-end">
                
                                                                <button type="button" className="btn btn-secondary btn-sm text-white" onClick={() => handleTeamDelete()}>
                                                                    <span className="me-2">{translation("proceed_text")}</span>
                                                                    {loading &&
                                                                        <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                            <span className="visually-hidden">Loading...</span>
                                                                        </div>
                                                                    }
                                                                    {!loading &&
                                                                        <span><i className="fa fa-hand-o-right" aria-hidden="true"></i></span>
                                                                    }
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                        

                                    }

                                    {!sub_team_id &&
                                        <div className="col-12 col-md-6 col-lg-3">
                                            <div className="team-members-wrap h-100 bg-white shadow-sm pt-3 pb-5 px-4 d-flex flex-column justify-content-center border rounded-3">
                                                <div className="d-flex align-items-center flex-column mb-4">
                                                    <h4>{translation("sub_teams_text")}</h4>
                                                </div>

                                                { subTeams && subTeams.length > 0 &&
                                                    <div className="sub-teams mb-4">
                                                        <ol>
                                                        { subTeams.map( (subTeam, index) => {
                                                                return(
                                                                    <li key={index}>
                                                                        <Link to={`/organizations/${organization_id}/teams/${team_id}/sub-teams/${subTeam?.ID}`} className="">{subTeam?.team_name}</Link>
                                                                    </li>
                                                                )
                                                        })}
                                                        </ol>
                                                    </div>
                                                }

                                                {(canEdit || Object.values(userData?.roles).includes("administrator")) &&
                                                    <Link to={`/organizations/${organization_id}/teams/${team_id}/new-sub-team/`} className="btn btn-halite-blue mb-2 rounded-pill" >
                                                        <span className="pe-2">{translation("add_new_sub_team")}</span>
                                                        <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                                    </Link>
                                                }

                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            
                        </div>
                    }
                </>
            }

        </div>
    )

}

export default SingleTeam;